export const addScreenAction = (payload) => {
  return {
    type: "ADD_SCREEN",
    payload,
  };
};

export const updateScreenAction = (payload) => {
  return {
    type: "UPDATE_SCREEN",
    payload,
  };
};

export const backScreenAction = (payload) => {
  return {
    type: "BACK_SCREEN",
    payload
  };
};

export const resetAction = () => {
  return {
    type: "RESET",
  };
};
